import { CustomColumn, TargetColumnValue } from '@barthauer/abc/core/data';
import DevExpress from 'devextreme';

export class AbcDropDownBoxRefColumnConfiguration {
  objectType?: string | number;
  refColumnName?: string;
  objectId?: string;
  initialValue?: string;
  initialDescription?: string;
  valueExpr?: string;
  displayExpr?: string;
  targetColumns?: TargetColumnValue[];
  customFilterExpression?: string;
  customColumns?: CustomColumn[];
}

export class AbcDropDownBoxPicklistConfiguration {
  picklistName: string;
  initialValue?: string;
  initialDescription?: string;
}

export class AbcDropDownBoxArrayDataConfiguration {
  dataSource: Array<object>;
  valueExpr?: string;
  displayExpr?: string;
  gridColumns?: DevExpress.ui.dxDataGrid.Column[];
  initialValue?: unknown;
}
